import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax
import bemify, { toModifiers } from 'bemify-js';

import Dropdown from 'app/common/components/Dropdown';
import KindPropType from 'app/common/KindPropType';
import OutsideClickable from 'app/common/components/OutsideClickable';
import Menu, { MenuSectionShape } from 'app/common/components/Menu';
import { getRef, setRef } from 'app/common/utils/ReactUtils';
import 'app/common/components/DropdownMenu.scss';

const block = 'dropdown-menu-v2';
const bem = bemify(block);

export const DropdownMenuWrapper = props => (
  <div
    className={bemify(`${block}-wrapper`)(
      toModifiers(props.kind),
      props.className
    )}
  >
    {props.children}
  </div>
);

const DropdownMenu = createReactClass({
  displayName: 'DropdownMenu',
  size: {},
  mixins: [PureRenderMixin],

  propTypes: {
    children: MenuSectionShape.children,
    items: MenuSectionShape.items,
    kind: KindPropType.isRequired,
    listStyles: PropTypes.object,
    Menu: PropTypes.func.isRequired,
    shouldRetainSize: PropTypes.bool,
    className: PropTypes.string,
    style: PropTypes.object,
    onClickOutside: PropTypes.func,
  },

  getDefaultProps() {
    return {
      kind: 'below justify-right',
      Menu,
      shouldRetainSize: false,
    };
  },

  computeInitialSize() {
    const menu = getRef(this, 'menu');

    // Using `offset*` instead of `getBoundingClientRect`
    // because the latter returns non-integers.
    // Also storing on `this` instead of `state` because
    // this is intended to be constant throughout the
    // life of the component and we don't want `state`
    // in this component anyway.
    this.size = {
      height: menu.offsetHeight,
      width: menu.offsetWidth,
    };
  },

  componentDidMount() {
    if (this.props.shouldRetainSize) {
      this.computeInitialSize();
    }
  },

  render() {
    const MenuComponent = this.props.Menu;

    const menu = (
      <Dropdown
        className={this.props.className}
        css={{
          ...(this.props.style || {}),
          ...(this.size || {}),
        }}
        kind={this.props.kind}
        ref={setRef(this, 'menu')}
      >
        <MenuComponent
          className={bem('__menu')}
          {..._.omit(this.props, [
            'className',
            'kind',
            'Menu',
            'shouldRetainSize',
            'onClickOutside',
          ])}
        />
      </Dropdown>
    );
    return this.props.onClickOutside ? (
      <OutsideClickable onClickOutside={this.props.onClickOutside}>
        {menu}
      </OutsideClickable>
    ) : (
      menu
    );
  },
});

export default DropdownMenu;
